import { repositorySign } from "../_base/_const/_constVar";
import Repository from "../_base/helper/HttpHelper";
import { MessageResponse } from "../model/MessageResponse";
import { SelectListItem } from "../model/SelectListItem";
import { TreeChartModel } from "../model/TreeChartModel";

export async function getUsersSelect(dep?: number) {
  let url = "/api/v1/Users/get-select";
  if (dep) url += `?dep=${dep}`;
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}

export async function getProcessDefSelect() {
  let url = "/api/v1/SampleProcess/get-select";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}

export async function getOrganizationsSelect() {
  let url = "/api/v1/Department/get-select";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
export async function getOrganizationsChartTree() {
  let url = "/select/organizations-tree";
  let callapi = await repositorySign.get<MessageResponse<TreeChartModel[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
export async function getEcmClassSelect() {
  let url = "/select/ecm-class";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
export async function getPartnersSelect() {
  let url = "/select/partners";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
export async function getBranchSelect() {
  let url = "/api/v1/TblDmInventory/get-select-branch";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}

export async function getDocTypSelect() {
  let url = "/api/v1/TblDocType/get-select";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
export async function getDepartmentSelect() {
  let url = "/api/v1/Department/get-select";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}

export async function getRoleSelect() {
  let url = "/api/v1/Role/get-select";
  let callapi = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    url
  );
  if (callapi?.success) return callapi?.data;
  return [];
}
